export default "__VITE_PUBLIC_ASSET__6ca6abe9__"